// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorLogin_error__26TRZ"};